import type { RouteRecordRaw } from 'vue-router';

import BrandListView from '@/company/brand/views/BrandListView.vue';
import BrandCreateView from '@/company/brand/views/BrandCreateView.vue';
import BrandEditView from '@/company/brand/views/BrandEditView.vue';
import BrandDeleteView from '@/company/brand/views/BrandDeleteView.vue';
import NavigationRailView from '@/services/router/views/NavigationRailView.vue';
import WrapperView from '@/shared/views/WrapperView.vue';
import useAppBranding from '@/services/app-branding/composables/useAppBranding';

const { hasWinckBranding } = useAppBranding();

const routes: RouteRecordRaw[] = [
    {
        path: hasWinckBranding() ? '/merken' : '/websites',
        name: 'brand',
        components: {
            default: WrapperView,
            rail: NavigationRailView,
        },
        redirect: { name: 'brand-list' },
        children: [
            {
                path: '',
                name: 'brand-list',
                components: {
                    default: BrandListView,
                },
                children: [
                    {
                        path: ':brandId/verwijderen',
                        name: 'brand-delete',
                        components: {
                            default: BrandDeleteView,
                        },
                    },
                ],
            },
            {
                path: 'aanmaken',
                name: 'brand-create',
                components: {
                    default: BrandCreateView,
                },
            },
            {
                path: ':brandId',
                name: 'brand-edit',
                components: {
                    default: BrandEditView,
                },
            },
        ],
        meta: {
            allowedRoles: [
                'company-manager',
            ],
        },
    },
];

export default routes;
